export default __webpack_public_path__ + "static/media/render2.9185c7b9.jpg";